
import MessageCard from "@/components/refund/messages/MessageCard";
import { Message } from "@/types/message";

interface AIResponsePreviewProps {
  responseContent: string;
  tone?: string;
  merchant: string;
  customInstructions?: string;
}

const AIResponsePreview = ({ 
  responseContent, 
  tone, 
  merchant,
  customInstructions 
}: AIResponsePreviewProps) => {
  if (!responseContent) return null;
  
  const message: Message = {
    id: 'demo-ai',
    type: 'ai',
    content: responseContent,
    timestamp: new Date(),
    metadata: { 
      tone: tone as any,
      customInstructions
    }
  };

  return (
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-3">AI Generated Response</h3>
      <MessageCard 
        message={message}
        companyName={merchant}
        isLatestMessage={true}
        isLatestAIMessage={true}
        sellerEmail="" // Default empty string as it's a preview
      />
    </div>
  );
};

export default AIResponsePreview;
